/**
 * Notes des livreurs et réglage « Note auto ».
 *
 * `platform_config.auto_rating` est un NUMÉRIQUE (4,5 par défaut, entre 1 et 5,
 * migration 0027). Le portage TypeScript l'avait typé en booléen, et l'écran
 * Config affichait `config.notationAuto ? 1 : 0` : n'importe quelle note non nulle
 * s'affichait « 1 ». Ces fonctions lisent le champ comme ce qu'il est.
 */

export const NOTE_AUTO_DEFAUT = 4.5

/** Valeur lue en base (nombre, ou texte selon le pilote) → nombre à une décimale. */
export function noteAutoDepuisBase(brut: unknown): number {
  const n = typeof brut === 'string' ? Number(brut.replace(',', '.')) : brut
  if (typeof n !== 'number' || !Number.isFinite(n) || n < 1 || n > 5) return NOTE_AUTO_DEFAUT
  return Math.round(n * 10) / 10
}

/** Saisie du champ → valeur à enregistrer. La base borne entre 1 et 5 (`numeric(2,1)`). */
export function validerNoteAuto(saisie: string): number {
  const n = Number(String(saisie).trim().replace(',', '.'))
  if (String(saisie).trim() === '' || !Number.isFinite(n) || n < 1 || n > 5) {
    throw new Error('Note attendue entre 1 et 5 (par exemple 4,5).')
  }
  return Math.round(n * 10) / 10
}

/** Affichage français : 4,5 (virgule), jamais 4.5. */
export const formaterNote = (n: number): string => String(n).replace('.', ',')

export interface NoteLivreur {
  /** Note mixte (avis + auto), `null` tant que le livreur n'a rien livré ni reçu d'avis. */
  note: number | null
  /** Avis clients avec une note livreur ; `null` = la base ne sait pas encore le dire (0048 absente). */
  avis: number | null
  /** Livraisons sans note, comptées à la note automatique. */
  sansAvis: number | null
}

/**
 * « 4,5/5 (3 avis clients + 5 auto) ».
 *
 * Trois états, à ne pas confondre : une note CONNUE avec son détail ; AUCUNE note
 * (livreur qui n'a encore rien livré — afficher « 0/5 » ou « 5/5 » serait mentir
 * dans un sens ou dans l'autre) ; et le détail INCONNU quand la vue de la
 * migration 0048 n'est pas encore en ligne.
 */
export function descriptionNote(l: NoteLivreur): { principal: string; detail: string } {
  if (l.note === null) {
    return { principal: l.avis === null ? '—' : 'Pas encore noté', detail: '' }
  }
  const principal = `${formaterNote(l.note)}/5`
  if (l.avis === null || l.sansAvis === null) return { principal, detail: '' }
  const avis = `${l.avis} avis client${l.avis > 1 ? 's' : ''}`
  return { principal, detail: `(${avis} + ${l.sansAvis} auto)` }
}
